<template>
    <div class="index">
        <div class="header">
          <div class="header-top">
            <div class="clock">
                <clock style="font-size: 1rem; color: #6EDDF1;"></clock>
            </div>
            <div class="header-title">
                <h4>智慧食用菌数据可视化平台</h4>
          </div>
            <div class="selector-group">
              <el-select
                v-if="isSuperAdmin"
                v-model="selectedCompanyId"
                placeholder="选择公司"
                size="small"
                style="width: 180px; margin-right: 10px;"
                @change="onCompanyChange"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-select
                v-model="selectedGreenhouseId"
                placeholder="选择大棚"
                size="small"
                style="width: 160px;"
                @change="onGreenhouseChange"
                :disabled="greenhouseLoading"
              >
                <el-option
                  v-for="item in greenhouseList"
                  :key="item.id"
                  :label="item.name || item.label"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="login-box">
                <router-link to="/manage"><h2>管理</h2></router-link>
            </div>
            </div>
        </div>
        <div class="body">
            <Row class="page3">
                <Col :span="7">
                    <div class="left">
                        <span class='title'><span class="title-gradient">食用菌品类与培养方式</span></span>
                        <span class="angle1"></span>
                        <span class="angle2"></span>
                        <span class="angle3"></span>
                        <span class="angle4"></span>
                        <div class="left1" style="height:60%;">
                            <div style="height: 40%;display: flex; margin-top: 8%;">
                                <div style="height: 100%; width: 45%; margin-left: 5%;">
                                    <pie ref="chart3" id="pie_1" :data="pieData1"></pie>
                                </div>
                                <div style="height: 100%; width: 45%;">
                                    <pie ref="chart3" id="pie_3" :data="pieData2"></pie>
                                </div>
                            </div>
                            <!-- 删除“我国水产养殖主要鱼类”模块，留空位或后续替换为其他内容 -->
                            <div class="left-light">
                                <span class='title'><span class="title-gradient">光照强度(lx)</span></span>
                                <span class="angle1"></span>
                                <span class="angle2"></span>
                                <span class="angle3"></span>
                                <span class="angle4"></span>
                                <env-line :title="''" :series="envSeries.light"></env-line>
                            </div>
                        </div>
                        <div class="left1" style="height:36%;">
                            <chart1
                                    id="left_5"
                                    title="食用菌产量(吨)"
                                    :data="data3"
                                    ref="channelBar2"
                                ></chart1>
                        </div>
                    </div>
                </Col>
                <Col :span="10" style="padding:0 1%;">
                    <!-- 新增：摄像头监控区域 -->
                    <div class="camera-section">
                        <div class="camera-container">
                            <span class='title'><span class="title-gradient">实时监控画面</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <div class="video-wrapper">
                                <!-- 使用v-once防止播放器容器被重新渲染 -->
                                <div id="camera-player" ref="cameraPlayer" v-once></div>
                                <div v-if="videoLoading" class="video-loading">
                                  <div class="loading-spinner"></div>
                                  <p>视频加载中...</p>
                                </div>
                                <div v-if="videoError" class="video-error">
                                  <p>⚠️ 视频加载失败</p>
                                  <button @click="retryLoadVideo" class="retry-btn">重试</button>
                                </div>
                            </div>
                            <!-- 使用播放器自带控制栏（包含播放、暂停、静音、全屏等功能） -->
                            <!-- 采集按钮区域 -->
                            <div class="camera-capture">
                                <button 
                                    @click="selectSavePath" 
                                    class="path-btn"
                                    :disabled="isCapturing"
                                >
                                    选择保存路径
                                </button>
                                <span v-if="savePath" class="save-path">
                                    保存路径: {{ savePath }}
                                </span>
                                <button 
                                    @click="toggleCapture" 
                                    :class="['capture-btn', { 'capturing': isCapturing }]"
                                >
                                    {{ isCapturing ? '停止采集' : '开始采集' }}
                                </button>
                                <span v-if="isCapturing" class="capture-status">
                                    正在采集中... (已采集 {{ captureCount }} 张)
                                </span>
                                <!-- 调试信息（开发时可见） -->
                                <span v-if="!player && !videoError" class="debug-info" style="font-size: 11px; color: #888;">
                                    等待播放器初始化...
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="center-top" style="display: none;">
                        <china-map ref="chinaMap"></china-map>
                    </div>
                    <div class="center-bottom">
                        <span class='title'><span class="title-gradient">产量与出菇批次趋势</span></span>
                        <span class="angle1"></span>
                        <span class="angle2"></span>
                        <span class="angle3"></span>
                        <span class="angle4"></span>
                        <Row class="bottom-radars">
                            <Col span="12">
                                <radar
                                    id='bottom_1_1'
                                    :data=data5
                                    ref="chart1"
                                ></radar>
                            </Col>
                            <Col span="12">
                                <chart4
                                    id="bottom_2_1"
                                    :data="data9"
                                    ref="chart4"
                                ></chart4>
                            </Col>  
                        </Row>
                    </div>
                </Col>
                <Col :span="7">
                    <div class="right-1" style="height:20%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">棚外温度(℃)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.waitemp"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:20%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">棚外湿度(%)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.waihum"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:20%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">风速(m/s)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.fengsu"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:20%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">风向(°)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.fengxiang"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:32%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">温度(℃)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.temperature"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:32%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">湿度(%)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.humidity"></env-line>
                        </div>
                    </div>
                    <div class="right-1" style="height:32%;">
                        <div class="right1-1">
                            <span class='title'><span class="title-gradient">二氧化碳(ppm)</span></span>
                            <span class="angle1"></span>
                            <span class="angle2"></span>
                            <span class="angle3"></span>
                            <span class="angle4"></span>
                            <env-line :title="''" :series="envSeries.co2"></env-line>
                        </div>
                    </div>
                    
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
const chinaMap  = () => import('./components/index/chinaMap');
const pie = ()=> import('./components/pie');
const radar = ()=> import('./components/radar');
const chart1 = ()=> import('./components/index/chart1');
// 删除鱼类模块图表
// const chart3 = ()=>import('./components/index/chart3');
const chart4 = ()=> import('./components/index/chart4');
// 移除质量与经济模块组件
const envLine = ()=> import('./components/index/envLine');
const clock = ()=> import('./components/clock');

export default {
    name: 'index',
    components: {
        chinaMap,
        chart1,
        pie,
        // chart3,
        radar,
        chart4,
        // chart7,
        envLine,
        clock
    },
    data() {
        return {
            user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
            isSuperAdmin: false,
            selectedCompanyId: null,
            selectedGreenhouseId: null,
            companyList: [],
            greenhouseList: [],
            greenhouseLoading: false,
            // 实时环境数据
            env: {
                temperature: '--',
                humidity: '--',
                co2: '--',
                light: '--',
            },
            // 多传感器折线图数据结构：每类指标一个 series 数组
            envSeries: {
                waitemp: [ { name: '棚外温度', data: [] } ],
                waihum: [ { name: '棚外湿度', data: [] } ],
                fengsu: [ { name: '风速', data: [] } ],
                fengxiang: [ { name: '风向', data: [] } ],
                temperature: [ { name: '传感器A', data: [] }, { name: '传感器B', data: [] }, { name: '传感器C', data: [] } ],
                humidity: [ { name: '传感器A', data: [] }, { name: '传感器B', data: [] }, { name: '传感器C', data: [] } ],
                co2: [ { name: '传感器A', data: [] }, { name: '传感器B', data: [] }, { name: '传感器C', data: [] } ],
                light: [ { name: '传感器A', data: [] }, { name: '传感器B', data: [] }, { name: '传感器C', data: [] } ],
            },
            lastUpdated: '--',
            envTimer: null,
            
            // 左下横向条：示例写死数据（近年产量Top）
            data3: [
                { data: { name: '香菇', value: 5200, color: '#0E4CFF' } },
                { data: { name: '平菇', value: 4300, color: '#FE9900' } },
                { data: { name: '金针菇', value: 3900, color: '#7F05FD' } },
                { data: { name: '杏鲍菇', value: 3500, color: '#EE82EE' } },
                { data: { name: '白玉菇', value: 2200, color: '#FF0000' } }
            ],
            // 删除 data2（鱼类模块数据）
            // 模块二雷达图数据1
            data5: {
                title: '食用菌生产要素权重',
                position: ['5%', '14%'],
                center: ['50%', '60%'],
                indicator: [
                    { text: '菌种质量' },
                    { text: '培养基' },
                    { text: '温湿控制' },
                    { text: 'CO2与通风' },
                    { text: '光照与补光' }
                ],
                data: [
                    {
                        name: '综合得分',
                        color: '#0DE4EE',
                        value: [85, 78, 90, 75, 60]
                    },
                ]
            },
            data9: {
                title: '产量与出菇批次',
                data: [
                    {
                        name: '产量',
                        color: '#00CCFF',
                        value: [120, 150, 180, 170, 210, 240, 260]
                    },
                    {
                        name: '出菇批次',
                        color: '#142AFE',
                        value: [3, 4, 5, 4, 6, 6, 7]
                    }
                ]
            },
            pieData1: {// 饼图数据1
                title: "食用菌品类占比",
                color: '#2C7BFE',
                data: [
                    { name: '香菇', value: 35, itemStyle: { color: '#ff7f50' } },
                    { name: '平菇', value: 25, itemStyle: { color: '#87cefa' } },
                    { name: '金针菇', value: 18, itemStyle: { color: '#da70d6' } },
                    { name: '杏鲍菇', value: 12, itemStyle: { color: '#32cd32' } },
                    { name: '其他', value: 10, itemStyle: { color: '#6495ed' } }
                ],
            },
            pieData2: {// 饼图数据1
                title: "培养方式占比",
                color: '#2C7BFE',
                data: [
                    { name: '工厂化', value: 45, itemStyle: { color: '#ffcc00' } },
                    { name: '袋料', value: 28, itemStyle: { color: '#3399ff' } },
                    { name: '瓶栽', value: 17, itemStyle: { color: '#7f05fd' } },
                    { name: '段木', value: 10, itemStyle: { color: '#ee82ee' } }
                ],
            },
            resizeFn: null,
            piecolors1: ["#ff7f50", "#87cefa", "#da70d6", "#32cd32", "#6495ed"],
            piecolors2: ["#ffcc00", "#3399ff"],
            linecolors1 : ["#0E4CFF", "#FE9900", "#7F05FD", "#EE82EE", "#FF0000"],
            
            // 摄像头相关数据
            cameraUrl: '',
            accessToken: '',
            isPlaying: false,
            isMuted: true,
            videoLoading: false,
            videoError: false,
            cameraTimer: null,
            player: null, // EZUIKit播放器实例
            playerInitialized: false, // 播放器是否已初始化标志
            
            // 采集相关数据
            isCapturing: false, // 是否正在采集
            captureTimer: null, // 采集定时器
            captureCount: 0, // 采集计数
            savePath: '', // 保存路径（浏览器限制，实际使用下载方式）
            saveDirectoryHandle: null, // File System Access API的目录句柄
            debounceTimer: null, // 防抖定时器
        }
    },
    methods: {
      computeCo2(item) {
        if (!item) return '--';
        // 支持多种字段名：co21/co22/co23 或 旧的 co2
        const vals = [];
        if (item.co21 != null && item.co21 !== 0) vals.push(Number(item.co21));
        if (item.co22 != null && item.co22 !== 0) vals.push(Number(item.co22));
        if (item.co23 != null && item.co23 !== 0) vals.push(Number(item.co23));
        if (vals.length > 0) {
          const sum = vals.reduce((a,b) => a+b, 0);
          return Math.round((sum / vals.length) * 100) / 100;
        }
        if (item.co2 != null) return item.co2;
        return '--';
      },
      async initSelection() {
        // 根据 role 字段判断是否为超级管理员，而不是根据 companyid
        this.isSuperAdmin = this.user && this.user.role === '超级管理员';
        console.log('用户信息:', this.user);
        console.log('是否为超级管理员:', this.isSuperAdmin);
        if (this.isSuperAdmin) {
          await this.loadCompanies();
          if (!this.selectedCompanyId && this.companyList.length > 0) {
            this.selectedCompanyId = this.companyList[0].id;
          }
        } else {
          this.selectedCompanyId = this.user ? this.user.companyid : null;
        }
        await this.loadGreenhouses(this.selectedCompanyId);
        if (!this.selectedGreenhouseId && this.greenhouseList.length > 0) {
          this.selectedGreenhouseId = this.greenhouseList[0].id;
        }
      },
      async loadCompanies() {
        try {
          const res = await axios.get('/api/companies');
          this.companyList = Array.isArray(res.data) ? res.data : [];
        } catch (e) {
          this.companyList = [];
        }
      },
      async loadGreenhouses(companyId) {
        this.greenhouseLoading = true;
        try {
          if (!companyId) {
            this.greenhouseList = [];
            return;
          }
          const res = await axios.get('/api/greenhouses/list', {
            params: { companyId }
          });
          this.greenhouseList = Array.isArray(res.data) ? res.data : [];
        } catch (e) {
          this.greenhouseList = [];
        } finally {
          this.greenhouseLoading = false;
        }
      },
      onCompanyChange(id) {
        this.selectedCompanyId = id;
        this.selectedGreenhouseId = null;
        this.loadGreenhouses(id).then(() => {
          if (!this.selectedGreenhouseId && this.greenhouseList.length > 0) {
            this.selectedGreenhouseId = this.greenhouseList[0].id;
          }
          this.refreshAll();
        });
      },
      onGreenhouseChange(id) {
        this.selectedGreenhouseId = id;
        this.refreshAll();
      },
      refreshAll() {
        this.stopEnvPolling();
        this.startEnvPolling();
        this.refreshVideo();
      },
      //摄像头相关方法
      async loadCameraStream() {
        // 如果播放器已经初始化且正常运行，不重复加载
        if (this.playerInitialized && this.player && !this.videoError) {
          console.log('播放器已正常运行，跳过重复加载');
          return;
        }

        console.log('=== loadCameraStream 开始 ===');
        console.log('selectedCompanyId:', this.selectedCompanyId);
        console.log('selectedGreenhouseId:', this.selectedGreenhouseId);

        try {
          this.videoLoading = true;
          this.videoError = false;

          console.log('开始加载摄像头视频流...');

          // 先加载EZUIKit SDK
          await this.loadEzuikit();

          // 获取AccessToken
          await this.getAccessToken();

          // 调用后端API获取摄像头直播地址（ezopen协议）
          console.log('=== 发送获取直播地址请求 ===');
          console.log('请求参数:', { companyId: this.selectedCompanyId, greenhouseId: this.selectedGreenhouseId });
          const response = await axios.get('/api/ezviz/live-url', {
            params: {
              companyId: this.selectedCompanyId,
              greenhouseId: this.selectedGreenhouseId
            }
          });

          console.log('API响应:', response.data);

          if (response.data && response.data.code === '200') {
            const videoUrl = response.data.data;
            console.log('获取到摄像头地址:', videoUrl);

            if (!videoUrl) {
              throw new Error('获取到的视频地址为空');
            }

            // 设置视频源
            this.cameraUrl = videoUrl;

            // 初始化EZUIKit播放器（内部已处理DOM更新）
            // 只有在播放器未初始化或出错时才初始化
            if (!this.playerInitialized || this.videoError) {
              this.initEzuikitPlayer(videoUrl);
            }

          } else {
            throw new Error('获取摄像头地址失败: ' + (response.data.message || '未知错误'));
          }

        } catch (error) {
          console.error('加载摄像头失败:', error);
          this.videoLoading = false;
          this.videoError = true;
        }
      },

      // 加载EZUIKit SDK
      loadEzuikit() {
        return new Promise((resolve, reject) => {
          if (window.EZUIKit) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = '/js/ezuikit.js';
          script.onload = () => {
            console.log('EZUIKit SDK加载成功');
            resolve();
          };
          script.onerror = () => {
            console.error('EZUIKit SDK加载失败');
            reject(new Error('加载SDK失败'));
          };
          document.head.appendChild(script);
        });
      },

      // 获取AccessToken
      async getAccessToken() {
        try {
          const response = await axios.get('/api/ezviz/access-token');
          if (response.data && response.data.code === '200' && response.data.data) {
            this.accessToken = response.data.data;
            console.log('获取到AccessToken');
          } else {
            throw new Error('获取Token失败');
          }
        } catch (error) {
          console.error('获取accessToken出错:', error);
          throw new Error('无法获取访问令牌');
        }
      },

      // 初始化EZUIKit播放器
      initEzuikitPlayer(videoUrl) {
        // 如果播放器已经存在且正常运行，不重复初始化
        if (this.player && this.playerInitialized && !this.videoError) {
          console.log('播放器已初始化，跳过重复初始化');
          return;
        }

        // 销毁之前的播放器
        this.destroyPlayer();

        if (!window.EZUIKit || !window.EZUIKit.EZUIKitPlayer) {
          console.error('EZUIKit SDK未加载');
          this.videoError = true;
          this.videoLoading = false;
          return;
        }

        // 等待DOM更新完成，确保容器尺寸稳定
        this.$nextTick(() => {
          const playerContainer = document.getElementById('camera-player') || this.$refs.cameraPlayer;
          if (!playerContainer) {
            console.error('播放器容器元素未找到');
            this.videoError = true;
            this.videoLoading = false;
            return;
          }

          try {
            // 获取容器尺寸，使用getBoundingClientRect获取更准确的尺寸
            const rect = playerContainer.getBoundingClientRect();
            const containerWidth = rect.width || playerContainer.offsetWidth || 640;
            const containerHeight = rect.height || playerContainer.offsetHeight || 360;

            // 创建播放器
            this.player = new window.EZUIKit.EZUIKitPlayer({
              id: 'camera-player',
              width: containerWidth,
              height: containerHeight,
              template: 'pcLive',
              url: videoUrl,
              accessToken: this.accessToken,
              autoplay: true,
              aspectRatio: 'keep',
              audio: 0,
              controls: true,  // 启用播放器自带控制栏（包含全屏等功能）
              // 截图回调函数 - 捕获播放器返回的base64图片数据
              capturePictureCallBack: (data) => {
                console.log('[采集] 播放器capturePicture回调:', data);
                // data可能是文件路径或base64数据
                if (typeof data === 'string' && data.startsWith('data:image')) {
                  // 如果是base64数据，保存它
                  this.handlePlayerCaptureData(data);
                }
              }
            });

            // 播放器创建成功，立即更新状态（确保按钮可以点击）
            console.log('播放器对象已创建，player:', this.player);
            this.videoLoading = false;
            this.videoError = false;
            
            // 强制触发Vue响应式更新
            this.$forceUpdate();

            // 添加播放器事件监听
            this.player.on('error', (error) => {
              console.error('萤石播放器错误:', error);
              this.videoError = true;
              this.videoLoading = false;
              this.playerInitialized = false;
            });

            this.player.on('loaded', () => {
              console.log('播放器加载完成');
              this.videoLoading = false;
              this.isPlaying = true;
              this.playerInitialized = true; // 标记播放器已成功初始化
            });

            // 备用检测：如果loaded事件未触发，3秒后也认为播放器可用
        setTimeout(() => {
              if (this.player && !this.playerInitialized && !this.videoError) {
                console.log('播放器备用检测：认为播放器已可用');
                this.playerInitialized = true;
          this.videoLoading = false;
              }
            }, 3000);

            this.player.on('play', () => {
              this.isPlaying = true;
            });

            this.player.on('pause', () => {
              this.isPlaying = false;
            });

            // 监听capturePicture事件，获取截图数据（不触发下载）
            this.player.on('capturePicture', (event) => {
              console.log('[采集] 播放器capturePicture事件:', event);
              if (event && event.data) {
                // event.data包含base64数据，格式: {"fileName":"xxx.jpeg","base64":"data:image/jpeg;base64,..."}
                if (event.data.base64) {
                  console.log('[采集] 捕获到base64数据，长度:', event.data.base64.length);
                  // 直接使用base64数据，不触发下载
                  this.handlePlayerCaptureData(event.data.base64);
                } else {
                  console.warn('[采集] 事件数据中没有base64字段:', event.data);
                }
              } else {
                console.warn('[采集] 事件数据格式异常:', event);
              }
            });

          } catch (error) {
            console.error('初始化播放器失败:', error);
            this.videoError = true;
            this.videoLoading = false;
          }
        });
      },

      // 销毁播放器
      destroyPlayer() {
        if (this.player) {
          try {
            this.player.stop();
            this.player.destroy();
          } catch (e) {
            console.error('播放器销毁异常:', e);
          }
          this.player = null;
          this.playerInitialized = false; // 重置初始化标志
        }

        // 清理视频元素，确保彻底释放资源
        const container = document.getElementById('camera-player');
        if (container) {
          // 清空容器的HTML，确保所有资源被释放
          container.innerHTML = '';
          // 移除所有事件监听器
          const videoElement = container.querySelector('video');
          if (videoElement) {
            videoElement.src = '';
            videoElement.load();
          }
        }

        // 确保容器元素保持存在，避免DOM结构变化
        if (container && !container.parentNode) {
          // 如果容器被移除，重新添加到video-wrapper中
          const wrapper = this.$refs.cameraPlayer?.parentNode || document.querySelector('.video-wrapper');
          if (wrapper) {
            wrapper.appendChild(container);
          }
        }
      },

      togglePlay() {
        if (this.player) {
          if (this.isPlaying) {
            this.player.pause();
          } else {
            this.player.play();
          }
        }
      },

      toggleMute() {
        if (this.player) {
          // EZUIKit播放器的静音控制
          const currentAudio = this.player.getAudio();
          this.player.setAudio(currentAudio === 1 ? 0 : 1);
          this.isMuted = currentAudio === 1;
        }
      },

      refreshVideo() {
        // 清除之前的防抖定时器
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }

        console.log('=== refreshVideo 被调用 ===');
        console.log('selectedCompanyId:', this.selectedCompanyId);
        console.log('selectedGreenhouseId:', this.selectedGreenhouseId);
        this.videoLoading = true;
        this.videoError = false;
        // 先销毁播放器
        this.destroyPlayer();

        // 防抖：延迟500ms后再加载视频，让之前的流有时间释放
        this.debounceTimer = setTimeout(() => {
            this.$nextTick(() => {
                this.loadCameraStream();
            });
        }, 500);
      },

      retryLoadVideo() {
        this.videoLoading = true;
        this.videoError = false;
        // 先销毁播放器，等待DOM稳定后再重新加载
        this.destroyPlayer();
        this.$nextTick(() => {
        this.loadCameraStream();
        });
      },

      startCameraPolling() {
        // 每30秒检查一次摄像头状态
        this.cameraTimer = setInterval(() => {
          if (this.player && this.videoError) {
            console.log('检测到视频异常，重新加载...');
            this.refreshVideo();
          }
        }, 30000);
      },

      stopCameraPolling() {
        if (this.cameraTimer) {
          clearInterval(this.cameraTimer);
          this.cameraTimer = null;
        }
      },

      // 选择保存路径
      async selectSavePath() {
        try {
          // 检查浏览器是否支持 File System Access API
          if ('showDirectoryPicker' in window) {
            try {
              const directoryHandle = await window.showDirectoryPicker({
                mode: 'readwrite'
              });
              this.saveDirectoryHandle = directoryHandle;
              this.savePath = directoryHandle.name || '已选择文件夹';
              console.log('已选择保存路径:', directoryHandle.name);
              
              // 路径选择成功后，检查播放器状态并提示
              this.$nextTick(() => {
                if (!this.player) {
                  console.warn('播放器还未初始化，按钮可能仍为禁用状态');
                  console.log('当前状态 - player:', this.player, 'videoError:', this.videoError, 'videoLoading:', this.videoLoading);
                } else {
                  console.log('播放器已存在，按钮应该可以点击');
                }
              });
            } catch (error) {
              if (error.name !== 'AbortError') {
                console.error('选择路径失败:', error);
                alert('选择路径失败，将使用浏览器默认下载文件夹');
                this.savePath = '默认下载文件夹';
              }
            }
          } else {
            // 浏览器不支持 File System Access API，使用默认下载文件夹
            alert('您的浏览器不支持文件夹选择功能，图片将保存到默认下载文件夹。\n\n建议使用 Chrome 86+ 或 Edge 86+ 浏览器以获得完整功能。');
            this.savePath = '默认下载文件夹';
          }
        } catch (error) {
          console.error('选择路径异常:', error);
          this.savePath = '默认下载文件夹';
        }
      },

      // 切换采集状态
      toggleCapture() {
        if (this.isCapturing) {
          this.stopCapture();
        } else {
          this.startCapture();
        }
      },

      // 开始采集
      async startCapture() {
        // 检查播放器
        if (!this.player) {
          alert('播放器未初始化，无法开始采集。\n\n请等待视频加载完成后再试。');
          return;
        }

        // 检查路径
        if (!this.savePath) {
          const shouldSelect = confirm('请先选择保存路径。\n\n点击"选择保存路径"按钮选择文件夹，或点击"确定"使用默认下载文件夹。');
          if (shouldSelect) {
            await this.selectSavePath();
            // 如果用户取消了路径选择，使用默认路径
            if (!this.savePath) {
              this.savePath = '默认下载文件夹';
            }
          } else {
            // 用户取消，不开始采集
            return;
          }
        }

        // 如果还是没有路径，使用默认路径
        if (!this.savePath) {
          this.savePath = '默认下载文件夹';
        }

        const pathInfo = this.saveDirectoryHandle ? `已选择文件夹: ${this.savePath}` : `保存到: ${this.savePath}`;
        const confirmStart = confirm(`图片将每5秒自动截取一张。\n${pathInfo}\n\n是否开始采集？`);
        if (!confirmStart) {
          return;
        }

        this.isCapturing = true;
        this.captureCount = 0;

        // 立即截取第一张
        this.captureImage();

        // 每5秒截取一张
        this.captureTimer = setInterval(() => {
          this.captureImage();
        }, 5000);

        console.log('开始采集，每5秒截取一张图片');
      },

      // 停止采集
      stopCapture() {
        this.isCapturing = false;
        if (this.captureTimer) {
          clearInterval(this.captureTimer);
          this.captureTimer = null;
        }
        console.log(`采集结束，共采集 ${this.captureCount} 张图片`);
      },

      // 使用Canvas截取整个容器（不依赖外部库）
      async captureContainerWithCanvas(container) {
        try {
          const rect = container.getBoundingClientRect();
          const width = rect.width;
          const height = rect.height;
          
          if (width <= 0 || height <= 0) {
            console.warn('[采集] 容器尺寸无效');
            return null;
          }

          // 创建canvas
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');

          // 尝试截取容器内容
          // 注意：这种方法只能截取可见的DOM元素，无法截取iframe或特殊渲染的内容
          // 但可以尝试截取容器的背景和可见内容
          
          // 方法1: 尝试使用drawImage截取（如果容器是img或video）
          const img = container.querySelector('img');
          if (img && img.complete) {
            ctx.drawImage(img, 0, 0, width, height);
            return canvas.toDataURL('image/png');
          }

          // 方法2: 查找所有可见的video元素并合并
          const videos = container.querySelectorAll('video');
          if (videos.length > 0) {
            // 取第一个可见的video
            for (let video of videos) {
              if (video.readyState >= 2 && (video.videoWidth > 0 || video.offsetWidth > 0)) {
                const videoRect = video.getBoundingClientRect();
                const videoX = videoRect.left - rect.left;
                const videoY = videoRect.top - rect.top;
                ctx.drawImage(video, videoX, videoY, videoRect.width, videoRect.height);
                return canvas.toDataURL('image/png');
              }
            }
          }

          // 方法3: 查找canvas元素
          const canvases = container.querySelectorAll('canvas');
          if (canvases.length > 0) {
            for (let canvasEl of canvases) {
              if (canvasEl.width > 0 && canvasEl.height > 0) {
                const canvasRect = canvasEl.getBoundingClientRect();
                const canvasX = canvasRect.left - rect.left;
                const canvasY = canvasRect.top - rect.top;
                ctx.drawImage(canvasEl, canvasX, canvasY, canvasRect.width, canvasRect.height);
                return canvas.toDataURL('image/png');
              }
            }
          }

          return null;
        } catch (e) {
          console.error('[采集] Canvas截取容器失败:', e);
          return null;
        }
      },

      // 处理播放器capturePicture返回的base64数据（不触发下载）
      async handlePlayerCaptureData(base64Data) {
        if (!this.saveDirectoryHandle) {
          console.warn('[采集] 未选择保存路径，无法保存播放器截图');
          return;
        }

        if (!base64Data || typeof base64Data !== 'string') {
          console.error('[采集] base64数据无效');
          return;
        }

        try {
          console.log('[采集] 收到播放器base64截图数据，开始解码并保存');
          
          // base64数据格式: "data:image/jpeg;base64,/9j/4AAQ..."
          // 提取base64字符串部分
          let base64String = base64Data;
          let mimeType = 'image/jpeg'; // 默认jpeg
          
          if (base64Data.includes(',')) {
            const parts = base64Data.split(',');
            const dataPart = parts[0]; // "data:image/jpeg;base64"
            base64String = parts[1]; // 实际的base64字符串
            
            // 提取MIME类型
            if (dataPart.includes('image/')) {
              const mimeMatch = dataPart.match(/image\/([^;]+)/);
              if (mimeMatch) {
                mimeType = `image/${mimeMatch[1]}`;
              }
            }
          }
          
          console.log('[采集] 图片类型:', mimeType, 'base64长度:', base64String.length);
          
          // 解码base64为Blob
          const byteString = atob(base64String);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeType });
          
          // 生成文件名（使用时间戳）
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
          
          const extension = mimeType === 'image/png' ? 'png' : 'jpeg';
          const fileName = `${year}${month}${day}_${hours}${minutes}${seconds}_${milliseconds}.${extension}`;
          
          // 直接保存到指定文件夹（不触发下载）
          const fileHandle = await this.saveDirectoryHandle.getFileHandle(fileName, { create: true });
          const writable = await fileHandle.createWritable();
          await writable.write(blob);
          await writable.close();
          
          this.captureCount++;
          console.log('[采集] 播放器截图保存成功:', fileName, '已采集', this.captureCount, '张');
        } catch (error) {
          console.error('[采集] 处理播放器截图数据失败:', error);
        }
      },

      // 截取图片 - 通过后端API截图（不触发浏览器下载）
      async captureImage() {
        if (!this.saveDirectoryHandle) {
          console.error('[采集] 未选择保存路径');
          return;
        }

        try {
          console.log('[采集] 调用后端API截图');

          // 获取当前正在观看的摄像头信息
          const currentCamera = this.cameraList[this.currentCameraIndex];
          const deviceSerial = currentCamera ? currentCamera.deviceSerial : null;
          const channelNo = currentCamera ? currentCamera.channel : null;

          console.log('[采集] 当前摄像头信息:', { deviceSerial, channelNo });

          // 调用后端截图API，传递当前摄像头信息
          const response = await axios.get('/api/ezviz/capture', {
            params: {
              companyId: this.selectedCompanyId,
              greenhouseId: this.selectedGreenhouseId,
              deviceSerial: deviceSerial,
              channelNo: channelNo
            }
          });
          
          if (response.data && response.data.code === '200' && response.data.data) {
            // 获取base64数据
            let base64Data = response.data.data;
            
            // 确保base64数据格式正确
            if (!base64Data.startsWith('data:image')) {
              base64Data = 'data:image/jpeg;base64,' + base64Data;
            }
            
            console.log('[采集] 后端返回base64数据，长度:', base64Data.length);
            
            // 保存图片
            const saved = await this.saveImage(base64Data);
            if (saved) {
              this.captureCount++;
              console.log('[采集] 截图保存成功，已采集', this.captureCount, '张');
            } else {
              console.error('[采集] 截图保存失败');
            }
          } else {
            console.error('[采集] 后端API返回错误:', response.data);
          }
        } catch (error) {
          console.error('[采集] 调用后端截图API失败:', error);
        }
      },

      // 检查图片是否全黑
      isImageBlack(imageData) {
        try {
          const img = new Image();
          return new Promise((resolve) => {
            img.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = Math.min(50, img.width); // 只检查前50x50像素
              canvas.height = Math.min(50, img.height);
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              const pixels = imageData.data;
              
              let allBlack = true;
              for (let i = 0; i < pixels.length; i += 4) {
                // 检查RGB值，如果有一个不为0，就不是全黑
                if (pixels[i] > 10 || pixels[i + 1] > 10 || pixels[i + 2] > 10) {
                  allBlack = false;
                  break;
                }
              }
              resolve(allBlack);
            };
            img.onerror = () => resolve(true); // 加载失败认为是黑的
            img.src = imageData;
          });
        } catch (e) {
          return false; // 检查失败，不认为是黑的
        }
      },

      // 从video元素截取
      captureFromVideo(videoElement) {
        try {
          // 确保video真的在播放
          if (videoElement.paused) {
            console.warn('[截图] video未播放，尝试播放');
            videoElement.play().catch(e => {
              console.warn('[截图] 无法播放video:', e);
            });
          }

          // 优先使用video的实际视频尺寸
          let width = videoElement.videoWidth;
          let height = videoElement.videoHeight;
          
          // 如果videoWidth/Height为0，使用显示尺寸
          if (width <= 0 || height <= 0) {
            width = videoElement.offsetWidth || videoElement.clientWidth || 640;
            height = videoElement.offsetHeight || videoElement.clientHeight || 360;
            console.warn('[截图] 使用显示尺寸:', width, 'x', height);
          }
          
          if (width <= 0 || height <= 0) {
            console.warn('[截图] video尺寸无效:', width, height);
            return null;
          }
          
          // 创建canvas并绘制视频帧
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          
          // 等待一帧，确保video有内容
          try {
            ctx.drawImage(videoElement, 0, 0, width, height);
          } catch (drawError) {
            console.error('[截图] 绘制video到canvas失败:', drawError);
            return null;
          }
          
          // 转换为base64
          const dataUrl = canvas.toDataURL('image/png');
          console.log('[截图] 截图成功，尺寸:', width, 'x', height);
          return dataUrl;
        } catch (error) {
          console.error('[截图] 从video截取失败:', error);
          return null;
        }
      },

      // 从容器截取（使用html2canvas）
      async captureFromContainer(container) {
        try {
          // 优先使用html2canvas（需要安装html2canvas库）
          if (window.html2canvas) {
            console.log('使用html2canvas截图');
            const canvas = await window.html2canvas(container, {
              useCORS: true,
              allowTaint: false,
              backgroundColor: '#000000',
              scale: 1,
              logging: false,
              width: container.offsetWidth,
              height: container.offsetHeight
            });
            return canvas.toDataURL('image/png');
          }

          // 如果没有html2canvas，尝试查找iframe内的video
          const iframe = container.querySelector('iframe');
          if (iframe) {
            try {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
              const iframeVideo = iframeDoc.querySelector('video');
              if (iframeVideo && iframeVideo.readyState >= 2) {
                console.log('从iframe内的video截图');
                return this.captureFromVideo(iframeVideo);
              }
            } catch (e) {
              console.warn('无法访问iframe内容（可能是跨域限制）:', e);
            }
          }

          // 最后尝试：查找video-wrapper容器内的所有元素
          const videoWrapper = container.closest('.video-wrapper');
          if (videoWrapper) {
            const wrapperVideo = videoWrapper.querySelector('video');
            if (wrapperVideo && wrapperVideo.readyState >= 2) {
              console.log('从video-wrapper内的video截图');
              return this.captureFromVideo(wrapperVideo);
            }
          }

          console.warn('无法找到可截图的元素');
          return null;
        } catch (error) {
          console.error('从容器截取失败:', error);
          return null;
        }
      },

      // 保存图片 - 直接保存到选定目录，不触发浏览器下载
      async saveImage(imageData) {
        try {
          // 生成文件名：使用当前时间
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
          
          const fileName = `${year}${month}${day}_${hours}${minutes}${seconds}_${milliseconds}.png`;

          // 将base64转换为blob
          const byteString = atob(imageData.split(',')[1]);
          const mimeString = imageData.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });

          // 使用 File System Access API，直接保存到选择的文件夹
          try {
            const fileHandle = await this.saveDirectoryHandle.getFileHandle(fileName, { create: true });
            const writable = await fileHandle.createWritable();
            await writable.write(blob);
            await writable.close();
            console.log('[保存] 图片已保存到选定目录:', fileName);
            return true; // 成功保存
          } catch (error) {
            console.error('[保存] 保存到选择文件夹失败:', error);
            alert('保存图片失败，请检查文件夹权限。错误: ' + error.message);
            return false; // 保存失败
          }
        } catch (error) {
          console.error('[保存] 保存图片失败:', error);
          return false;
        }
      },

    // 获取实时环境数据（从数据库获取最新的几组传感器数据）
    async fetchEnvRealtime() {
      try {
        // 获取最新的传感器数据
        const res = await axios.get('/api/sensors/latest', {
          params: {
            companyId: this.selectedCompanyId,
            greenhouseId: this.selectedGreenhouseId
          }
        });
        const sensorData = res.data || [];
        
        // 如果数据为空，使用测试数据
        if (!sensorData.length) {
          // 为每个传感器添加测试数据
          ['sid1', 'sid2', 'sid3'].forEach((sensorId, index) => {
            const testData = {
              sid: sensorId,
              temp: 20 + Math.random() * 10 + index * 2,
              hum: 60 + Math.random() * 20 + index * 5,
              co2: 400 + Math.random() * 100 + index * 50,
              light: 200 + Math.random() * 300 + index * 100,
              createdAt: new Date().toISOString()
            };
            sensorData.push(testData);
          });
        }
        
        // 按传感器ID分组数据（sid1, sid2, sid3对应传感器A, B, C）
        const sensorGroups = {};
        sensorData.forEach(item => {
          // 将数字sid转换为字符串格式
          const rawSid = item.sid || item.sid1 || item.sid2 || item.sid3;
          const sensorId = rawSid ? `sid${rawSid}` : 'default';
          if (!sensorGroups[sensorId]) {
            sensorGroups[sensorId] = [];
          }
          sensorGroups[sensorId].push(item);
        });

        // 处理棚外环境数据（waitemp, waihum, fengsu, fengxiang）
        const outdoorMetrics = ['waitemp', 'waihum', 'fengsu', 'fengxiang'];
        outdoorMetrics.forEach(metric => {
          const metricKey = metric;
          if (this.envSeries[metric] && this.envSeries[metric][0]) {
            // 清空现有数据，重新设置
            this.envSeries[metric][0].data = sensorData.slice(-6).map(item => {
              const date = new Date(item.createdAt);
              const pad = (n) => (n < 10 ? '0' + n : '' + n);
              const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
              return {
                t: time,
                v: parseFloat(item[metricKey]) || 0
              };
            });
          }
        });

        // 获取传感器ID列表，按sid1, sid2, sid3排序
        const sensorIds = ['sid1', 'sid2', 'sid3'].filter(id => sensorGroups[id]);
        
        // 更新实时显示值（使用第一个传感器的数据）
        if (sensorIds.length > 0 && sensorGroups[sensorIds[0]].length > 0) {
          const firstSensor = sensorGroups[sensorIds[0]][0];
          this.env.temperature = firstSensor.temp ?? '--';
          this.env.humidity = firstSensor.hum ?? '--';
          this.env.co2 = this.computeCo2(firstSensor);
          this.env.light = firstSensor.light ?? '--';
        }
        
        // 更新各传感器的数据 - 使用所有历史数据来更新图表
        sensorIds.forEach((sensorId, index) => {
          const groupData = sensorGroups[sensorId];
          if (groupData && groupData.length > 0) {
            // 按时间排序，确保数据顺序正确
            const sortedData = groupData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            
            // 只取最近的6条数据
            const recentData = sortedData.slice(-6);
            
            // 更新各指标的数据
            ['temperature', 'humidity', 'co2', 'light'].forEach(metric => {
              const metricKey = metric === 'temperature' ? 'temp' : 
                              metric === 'humidity' ? 'hum' : metric;
              
              if (this.envSeries[metric] && this.envSeries[metric][index]) {
                // 清空现有数据，重新设置历史数据
                this.envSeries[metric][index].data = recentData.map(item => {
                  const date = new Date(item.createdAt);
                  const pad = (n) => (n < 10 ? '0' + n : '' + n);
                  // 只显示时间：几点几分
                  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
                  return {
                    t: time,
                    v: metric === 'co2' ? (parseFloat(this.computeCo2(item)) || 0) : (parseFloat(item[metricKey]) || 0)
                  };
                });
              }
            });
            
            // 更新实时显示值（使用最新的数据）
            const latestSensor = recentData[recentData.length - 1];
            if (index === 0) { // 只更新第一个传感器的实时显示值
              this.env.temperature = latestSensor.temp ?? '--';
              this.env.humidity = latestSensor.hum ?? '--';
              this.env.co2 = this.computeCo2(latestSensor);
              this.env.light = latestSensor.light ?? '--';
            }
          }
        });
        
        // 更新时间显示（使用第一个传感器的最新时间）
        if (sensorIds.length > 0 && sensorGroups[sensorIds[0]].length > 0) {
          const firstGroupData = sensorGroups[sensorIds[0]];
          const latestSensor = firstGroupData[firstGroupData.length - 1];
          if (latestSensor && latestSensor.createdAt) {
            this.lastUpdated = latestSensor.createdAt;
          }
        }
        
        // 为 CO2 单独构建三条线（co21/co22/co23），使用第一个传感器组的时间序列作为基准
        if (sensorIds.length > 0) {
          const firstGroup = sensorGroups[sensorIds[0]] || [];
          if (firstGroup.length > 0) {
            const sortedAll = firstGroup.sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt));
            const recentAll = sortedAll.slice(-6);
            const seriesCo21 = recentAll.map(item => {
              const date = new Date(item.createdAt);
              const pad = (n) => (n < 10 ? '0' + n : '' + n);
              const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
              return { t: time, v: parseFloat(item.co21) || 0 };
            });
            const seriesCo22 = recentAll.map(item => {
              const date = new Date(item.createdAt);
              const pad = (n) => (n < 10 ? '0' + n : '' + n);
              const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
              return { t: time, v: parseFloat(item.co22) || 0 };
            });
            const seriesCo23 = recentAll.map(item => {
              const date = new Date(item.createdAt);
              const pad = (n) => (n < 10 ? '0' + n : '' + n);
              const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
              return { t: time, v: parseFloat(item.co23) || 0 };
            });
            this.$set(this.envSeries, 'co2', [
              { name: 'co21', data: seriesCo21 },
              { name: 'co22', data: seriesCo22 },
              { name: 'co23', data: seriesCo23 }
            ]);
          }
        }
      } catch (e) {
        // 请求失败时不报错打断UI，仅保留上次值
      }
    },
    // 初始化传感器历史数据
    async initSensorHistory() {
      try {
        // 获取历史数据用于初始化图表
        const res = await axios.get('/api/sensors/history', {
          params: {
            limit: 30,
            companyId: this.selectedCompanyId,
            greenhouseId: this.selectedGreenhouseId
          }
        });
        const historyData = res.data || [];
        
        if (historyData.length === 0) {
          // 生成测试历史数据
          const now = new Date();
          for (let i = 0; i < 6; i++) {
            const time = new Date(now.getTime() - i * 5 * 60 * 1000); // 每5分钟一个数据点
            ['sid1', 'sid2', 'sid3'].forEach((sensorId, index) => {
              historyData.push({
                sid: sensorId,
                temp: 20 + Math.random() * 10 + index * 2,
                hum: 60 + Math.random() * 20 + index * 5,
                co21: 400 + Math.random() * 100 + index * 50,
                co22: 405 + Math.random() * 90 + index * 40,
                co23: 395 + Math.random() * 110 + index * 60,
                light: 200 + Math.random() * 300 + index * 100,
                createdAt: time.toISOString()
              });
            });
          }
        }
        
        // 按时间排序，确保数据顺序正确
        historyData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        
        // 按传感器组分组数据（sid1, sid2, sid3对应传感器A, B, C）
        const sensorGroups = {};
        historyData.forEach(item => {
          // 将数字sid转换为字符串格式
          const rawSid = item.sid || item.sid1 || item.sid2 || item.sid3;
          const sensorId = rawSid ? `sid${rawSid}` : 'default';
          if (!sensorGroups[sensorId]) {
            sensorGroups[sensorId] = [];
          }
          sensorGroups[sensorId].push(item);
        });
        
        // 获取传感器组ID列表，按sid1, sid2, sid3排序
        const sensorIds = ['sid1', 'sid2', 'sid3'].filter(id => sensorGroups[id]);
        
        // 为每个传感器组初始化数据
        sensorIds.forEach((sensorId, index) => {
          const groupData = sensorGroups[sensorId];
          
          // 初始化各指标的数据
          ['temperature', 'humidity', 'co2', 'light'].forEach(metric => {
            const metricKey = metric === 'temperature' ? 'temp' : 
                            metric === 'humidity' ? 'hum' : metric;
            
            if (this.envSeries[metric] && this.envSeries[metric][index]) {
              // 只取最近的6条数据
              const recentData = groupData.slice(-6);
              this.envSeries[metric][index].data = recentData.map(item => {
                const date = new Date(item.createdAt);
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                // 只显示时间：几点几分
                const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
                return {
                  t: time,
                  v: parseFloat(item[metricKey]) || 0
                };
              });
            }
          });
        });
      } catch (e) {
        // 初始化传感器历史数据失败，静默处理
      }
    },
    startEnvPolling() {
      // 先初始化历史数据，然后开始轮询
      this.initSensorHistory();
      // 立即拉一次，然后每5秒拉取一次
      this.fetchEnvRealtime();
      this.envTimer = setInterval(this.fetchEnvRealtime, 5000);
    },
    stopEnvPolling() {
      if (this.envTimer) {
        clearInterval(this.envTimer);
        this.envTimer = null;
      }
    },
    // 饼图使用写死的常识数据，取消远程请求
    fetchPieData1() {},
    fetchPieData2() {},
    async fetchlineData1() {
      try {
        const res = await axios.get("/api/aquaculture/getall"); // 后端接口
        if (res.data && Array.isArray(res.data)) {
          this.data3 = res.data.map((item, index) => ({
            // subtitle: `${item.amount.toFixed(2)}（万吨）`, // 格式化 amount 为 2 位小数
            // top: `${index * 27}%`, // 根据索引动态调整 top 值
            data: {
              name: item.name,
              value: item.amount,
              color: this.linecolors1[index] || "#cccccc", // 动态设置颜色
            },
          }));
        } else {
          console.warn("数据格式错误:", res.data);
        }
      } catch (error) {
        console.error("获取数据失败", error);
      }
    },
    // 取消鱼类数据请求
    fetchFishData() {},
    // 雷达与趋势使用示例写死数据
    fetchData() {},
    fetchlineData2() {},
    },
    async mounted() {
    await this.initSelection();
    this.startEnvPolling();
    this.fetchPieData1();
    this.fetchPieData2();
    this.fetchlineData1();
    this.fetchFishData();
    this.fetchData();
    this.fetchlineData2();
    // 加载摄像头视频流
    this.loadCameraStream();
    this.startCameraPolling();
    window.addEventListener('beforeunload', this.clearLocalStorage);
  },
  beforeDestroy() {
    this.stopEnvPolling();
    this.stopCameraPolling();
    // 停止采集
    this.stopCapture();
    // 清理播放器实例
    this.destroyPlayer();
    window.removeEventListener('beforeunload', this.clearLocalStorage);
  }

}
</script>

<style lang="less">

.index {
    height: 100%;
    display: flex;
    flex-direction: column;

    .header {
        width: 100%;
        background-color: #03044A;
        display: flex;
        flex-direction: column;
        padding: 10px 20px 20px;
        box-sizing: border-box;

        &-top {
            width: 100%;
            display: flex;
        align-items: center;
            justify-content: space-between;
        }

        &-title {
            color: #fff;
            font-size: 30px;
            letter-spacing: 15px;
            flex: 1;
            text-align: center;
            margin: 0 40px;

            h4 {
                margin: 0;
            }
        }

        .login-box {
            margin-right: 50px;

            h2 {
                margin: 0;
            }
        }

        .clock {
            margin-left: 20px;
        }

        .selector-group {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-right: 16px;
        }
    }

  /* 新增：摄像头区域样式 */
  .camera-section {
    width: 100%;
    height: calc(50% - 0.5%);
    margin-bottom: 1%;
    background-color: transparent;
    box-sizing: border-box;

    .camera-container {
      border: 1px solid #0D2451;
      position: relative;
      background: #151456;
      padding: 38px 16px 16px;
      height: 100%;
      width: 100%;

      .title {
        position: absolute;
        display: inline-block;
        color: #6EDDF1;
        height: 18px;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;

        .title-gradient {
          position: relative;
          font-size: 16px;
          background: #09102E;
          display: inline-block;
          padding: 0 10px;
          transform: translateY(-5px);
        }
      }

      .angle1, .angle2, .angle3, .angle4 {
        position: absolute;
        width: 12px;
        height: 12px;
        border: 1px solid #6EDDF1;
      }

      .angle1 {
        top: -1px;
        left: -1px;
        border-right: none;
        border-bottom: none;
      }

      .angle2 {
        top: -1px;
        right: -1px;
        border-left: none;
        border-bottom: none;
      }

      .angle3 {
        bottom: -1px;
        left: -1px;
        border-right: none;
        border-top: none;
      }

      .angle4 {
        bottom: -1px;
        right: -1px;
        border-left: none;
        border-top: none;
      }

      .video-wrapper {
        width: 100%;
        height: calc(100% - 80px);
        position: relative;
        background: #000;
        margin-top: 24px;
        border-radius: 6px;
        overflow: hidden;

        #camera-player {
          width: 100%;
          height: 100%;
        }

        .video-loading, .video-error {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          color: #6EDDF1;

          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #0D2451;
            border-top: 4px solid #6EDDF1;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 10px;
          }

          p {
            margin: 0;
            font-size: 14px;
          }

          .retry-btn {
            background: #6EDDF1;
            color: #03044A;
            border: none;
            padding: 5px 15px;
            border-radius: 3px;
            cursor: pointer;
            margin-top: 10px;

            &:hover {
              background: #5CB1C1;
            }
          }
        }
      }

      .camera-controls {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 10px;

        .control-btn {
          background: rgba(110, 221, 241, 0.2);
          color: #6EDDF1;
          border: 1px solid #6EDDF1;
          padding: 5px 15px;
          border-radius: 3px;
          cursor: pointer;
          font-size: 12px;

          &:hover {
            background: rgba(110, 221, 241, 0.4);
          }
        }
      }

      .camera-capture {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px 0;
        margin-top: 8px;
        border-top: 1px solid rgba(13, 36, 81, 0.5);

        .capture-btn {
          background: rgba(110, 221, 241, 0.2);
          color: #6EDDF1;
          border: 1px solid #6EDDF1;
          padding: 8px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s;
          min-width: 100px;

          &:hover:not(:disabled) {
            background: rgba(110, 221, 241, 0.4);
            transform: translateY(-1px);
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          &.capturing {
            background: rgba(255, 0, 0, 0.3);
            border-color: #ff4444;
            color: #ff6666;
            animation: pulse 2s infinite;

            &:hover {
              background: rgba(255, 0, 0, 0.4);
            }
          }
        }

        .capture-status {
          color: #6EDDF1;
          font-size: 13px;
          font-weight: 500;
        }

        .path-btn {
          background: rgba(110, 221, 241, 0.15);
          color: #6EDDF1;
          border: 1px solid #6EDDF1;
          padding: 6px 15px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 13px;
          transition: all 0.3s;

          &:hover:not(:disabled) {
            background: rgba(110, 221, 241, 0.3);
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }

        .save-path {
          color: #5CB1C1;
          font-size: 12px;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }


    .body {
        width: 100%;
        flex: 1;
        background-color: #03044A;
        display: flex;
        /* justify-content: space-between;
        align-items: center;
        flex-wrap: wrap; */
        .page3 {
            height: 100%;
            width: 100%;
            padding: 14px 20px 20px;
            background: #03044A;
            overflow: hidden;
            .ivu-col {
                height: 100%;
            }

            .left, .right1-1, .center-bottom {
                height: 100%;
                border: 1px solid #0D2451;
                position: relative;
                background: #151456;

                #left_5 {
                    height: 100%;
                    width: 100%;
                    //float: center;
                }

                #left_6 {
                    height: 100%;
                    width: 55%;
                    float: left;
                }

                .circular {
                    height: 100%;
                }

                .left1 {
                    border-bottom: 1px solid #0D2451;
                    background: #151456;
                }
                .left-light {
                    height: 60%;
                    border-bottom: 1px solid #0D2451;
                    background: #151456;
                    padding: 10px 12px 6px;
                }

                .title {
                    position: absolute;
                    display: inline-block;
                    color: #6EDDF1;
                    /* border: 2px solid #6EDDF1; */
                    height: 18px;
                    /* padding: 0 2px; */
                    left: 50%;
                    transform: translate(-50%, -50%);

                    .title-text {
                        position: relative;
                        font-size: 16px;
                        background: #09102E;
                        display: inline-block;
                        padding: 0 4px;
                        transform: translateY(-5px);
                    }
        }
    }

    .center-top {
        height: calc((100% - 33%) * 0.6);
        margin-bottom: 1%;
    }

    .center-bottom {
        height: calc(50% - 0.5%);

        .bottom-radars {
            height: 100%;
        }

        .bottom-bars {
            height: 45%;
        }
    }

    .right-1 {
        height: 30%;

        .right1-1 {
            height: 92%;
                padding: 10px 12px 6px;
                .env-panel {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    grid-auto-rows: 1fr;
                    gap: 10px;
                    height: calc(100% - 30px);
                    padding: 10px 8px 0;
                }
                .env-item {
                    background: rgba(9,16,46,0.6);
                    border: 1px solid #0D2451;
                    border-radius: 4px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: #6EDDF1;
                }
                .env-label {
                    font-size: 14px;
                    color: #5CB1C1;
                    margin-bottom: 4px;
                }
                .env-value {
                    font-size: 24px;
                    font-weight: 600;
                    color: #00CCFF;
                }
                .env-unit {
                    font-size: 12px;
                    color: #5CB1C1;
                    margin-left: 4px;
                }
                .env-time {
                    text-align: right;
                    color: #5CB1C1;
                    font-size: 12px;
                    padding: 0 12px 6px 0;
                }
        }
    }

    .right-2 {
        height: 40%;

    }
        }

    }
}

</style>